import React from 'react'

const NotFound = () => {
    return (
        <div className="flex items-center justify-center h-full mt-[13%]">
            <img src="./Web.png" alt="No Content" className="w-[400px] h-auto" />
        </div>
    )
}

export default NotFound